import { render, staticRenderFns } from "./HeaderGenerate.vue?vue&type=template&id=72f1a8c4&scoped=true"
import script from "./HeaderGenerate.vue?vue&type=script&lang=js"
export * from "./HeaderGenerate.vue?vue&type=script&lang=js"
import style0 from "./HeaderGenerate.vue?vue&type=style&index=0&id=72f1a8c4&prod&lang=scss&scoped=true"
import style1 from "./HeaderGenerate.vue?vue&type=style&index=1&id=72f1a8c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f1a8c4",
  null
  
)

export default component.exports